/*
  Sticky "Add to cart" bar (snippets/sticky-add-to-cart.liquid).

  - Shows the bar once the main Add to cart button has scrolled above the
    viewport, hides it again when the button is back on screen.
  - Clicking the bar's button clicks the main button, so the theme's own
    product form / ajax cart logic does the actual add to cart.
  - Mirrors the main button's text, disabled state and state classes
    (is-added etc.), plus the variant price, so variant changes show up.
*/
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    var sectionId = bar.dataset.sectionId;
    var form = document.getElementById('product-form-' + sectionId);
    var mainBtn = form && form.querySelector('[name="add"]');
    var mainButtons = form && form.querySelector('.js-product-buttons');
    if (!mainBtn || !mainButtons || !('IntersectionObserver' in window)) {
      bar.remove();
      return;
    }

    var stickyBtn = bar.querySelector('.js-sticky-atc-btn');
    var stickyText = bar.querySelector('.js-sticky-atc-text');
    var stickyPrice = bar.querySelector('.js-sticky-atc-price');
    var mainPrice = document.getElementById('price-' + sectionId);

    // Remove a stale copy left in <body> after a theme editor re-render.
    document.querySelectorAll('body > .js-sticky-atc[data-section-id="' + sectionId + '"]').forEach(function (old) {
      if (old !== bar) old.remove();
    });
    // Escape any transformed ancestor so position: fixed is relative to the viewport.
    document.body.appendChild(bar);

    function syncButton() {
      var text = mainBtn.querySelector('.product-form__add-btn__text') || mainBtn.querySelector('span');
      if (text) stickyText.textContent = text.textContent.trim();
      stickyBtn.disabled = mainBtn.disabled;

      ['is-added', 'is-loading', 'disabled'].forEach(function (cls) {
        stickyBtn.classList.toggle(cls, mainBtn.classList.contains(cls));
      });
    }

    function syncPrice() {
      if (!mainPrice || !stickyPrice) return;
      var number = mainPrice.querySelector('.price__number');
      var compare = mainPrice.querySelector('.price__compare');
      stickyPrice.innerHTML = (number ? number.outerHTML : '') + (compare ? compare.outerHTML : '');
      stickyPrice.style.visibility = mainPrice.classList.contains('visibility-hidden') ? 'hidden' : '';
    }

    function setVisible(visible) {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      stickyBtn.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('has-sticky-atc', visible);
      if (visible) {
        document.body.style.setProperty('--sticky-atc-height', bar.offsetHeight + 'px');
      }
    }

    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });

    new MutationObserver(syncButton).observe(mainBtn, {
      attributes: true,
      attributeFilter: ['class', 'disabled'],
      childList: true,
      characterData: true,
      subtree: true
    });

    if (mainPrice) {
      new MutationObserver(syncPrice).observe(mainPrice, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      // Only after the user has scrolled past the button, not before reaching it.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainButtons);

    syncButton();
    syncPrice();
  }

  function initAll() {
    document.querySelectorAll('.js-sticky-atc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
